import { render, staticRenderFns } from "./manage-categories.modal.vue?vue&type=template&id=d2410e1a&scoped=true"
import script from "./manage-categories.modal.vue?vue&type=script&lang=js"
export * from "./manage-categories.modal.vue?vue&type=script&lang=js"
import style0 from "./manage-categories.modal.vue?vue&type=style&index=0&id=d2410e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2410e1a",
  null
  
)

export default component.exports